
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';

@Component({
  components: {},
})
export default class DateSelection extends Vue {
  @Prop() public msg!: string;

  private menu1: any = false;
  private menu2: any = false;
  private startDate: string = moment().subtract(1, 'year').toISOString().substr(0, 10);
  private endDate: string = moment().toISOString().substr(0, 10);
  private minEndDate: string = '';

  @Watch('startDate')
  protected onStartDateChanged(newDate: string, oldDate: string): any {
    this.minEndDate = moment(newDate, 'YYYY-MM-DD').toISOString().substr(0, 10);
    this.$store.dispatch('setStartDate', newDate);
  }

  @Watch('endDate')
  protected onEndDateChanged(newDate: string, oldSDate: string): any {

    // Dont allow going below minimum
    if (moment(newDate, 'YYYY-MM-DD') < moment(this.minEndDate, 'YYYY-MM-DD')) {
       newDate = this.minEndDate;
    }

    this.$store.dispatch('setEndDate', newDate);
  }


  // private changeSubarea(old_selected_subarea: number, event: any) {
  //   this.selected_subarea = parseInt(event.target.value, 10);
  // }

  //

  private mounted() {
    this.$store.dispatch('setStartDate', this.startDate);
    this.$store.dispatch('setEndDate', this.endDate);

    this.$store.watch(
      (state) => {
        return this.$store.state.startDate; // Does not seem to work with Getter
      },
      (newValue, oldValue) => {

        this.startDate = newValue;
        // console.log(oldValue);
        // console.log(newValue);
      },
        // Optional Deep if you need it
        {
          deep: true,
        },
    );

    this.$store.watch(
      (state) => {
        return this.$store.state.endDate;
      },
      (newValue, oldValue) => {

        this.endDate = newValue;
      },
    );

    return;
  }
}
